import { Badge, DataTableRow, DataTableRowCell } from 'Elements';
import { Colors, JobKind, JobSearchAnalytics } from 'Types';
import { formatLocaleDateTime, getFilterByValue, jobStatus } from 'Utils';
import { useTranslation } from 'react-i18next';

export const DetailPartnerJobRow = ({
	partner,
	cellClassName
}: {
	partner: JobSearchAnalytics;
	cellClassName: (col: string) => string;
}) => {
	const { t } = useTranslation();

	return (
		<DataTableRow key={partner?.jobId}>
			<DataTableRowCell
				cellHead="table.title"
				cellClassName={cellClassName('title')}>
				<div className="d-flex align-items-center gap-3 ">
					<div className="d-flex flex-column gap-1 flex-grow-1">
						<h6 className="fs-sm fw-500 mb-0 lh-base">
							{partner?.jobTitle ?? '---'}
						</h6>
						<div>
							{partner?.visibility && (
								<Badge color={Colors.premium}>
									{t('label.premium')}
								</Badge>
							)}
						</div>
					</div>
				</div>
			</DataTableRowCell>
			<DataTableRowCell
				cellHead="table.job-type"
				cellClassName={cellClassName('job-type')}>
				<Badge
					color={
						partner?.jobKind === JobKind.Job
							? Colors.job
							: Colors.association
					}>
					{partner?.jobKind === JobKind.Job
						? t('menu.job')
						: t('badge.internship')}
				</Badge>
			</DataTableRowCell>
			<DataTableRowCell
				cellHead="table.status"
				cellClassName={cellClassName('status')}>
				<Badge
					color={
						partner
							? getFilterByValue(jobStatus, partner.jobStatus)
									?.color ?? Colors.primary
							: Colors.primary
					}>
					{partner
						? t(
								getFilterByValue(jobStatus, partner.jobStatus)
									?.label ?? ''
						  )
						: '...'}
				</Badge>
			</DataTableRowCell>
			<DataTableRowCell
				cellClassName={cellClassName('published-date')}
				cellHead="table.published-date">
				{partner?.publishedAt ? (
					<time
						dateTime={partner?.publishedAt}
						title={formatLocaleDateTime(
							partner?.publishedAt,
							false
						)}>
						{formatLocaleDateTime(partner?.publishedAt, false)}
					</time>
				) : (
					'----'
				)}
				{partner?.visibility?.topJobExpiredAt && (
					<div className="d-flex gap-3 mt-2">
						<Badge color={Colors.black}>{t('badge.top-job')}</Badge>
						<div className="d-flex gap-2">
							<span>{t('forms.expire-date')}:</span>
							<span>
								{formatLocaleDateTime(
									partner?.visibility?.topJobExpiredAt ?? '',
									false
								)}
							</span>
						</div>
					</div>
				)}
			</DataTableRowCell>
			<DataTableRowCell
				cellHead="table.total-view"
				cellClassName={cellClassName('total-view')}>
				<span>{partner?.totalView ?? 0}</span>
			</DataTableRowCell>
		</DataTableRow>
	);
};
